<template>
    <v-row>
        <v-col
                v-for="(number, index) in filterNumbers"
                :key="index"
                cols="12"
                xl="3"
                lg="4"
                md="6"
        >
            <v-card class="mx-auto" v-ripple @click="cardOnClick(number.inum)">
                <v-container>
                    <v-row justify="space-between">
                        <v-col cols="auto">
                            <v-card-title>
                                {{number.inum | msisdn}}
                            </v-card-title>
                            <v-card-subtitle class="pb-0">
                                {{number.price | price}} &#8381;
                            </v-card-subtitle>

                        </v-col>

                        <v-col
                                cols="auto"
                                class="text-center pl-0"
                        >
                            <v-row
                                    class="flex-column ma-0 fill-height"
                                    justify="center"
                            >
                                <v-col class="px-0" v-if="isVisibleAddButton(number.inum)">
                                    <v-btn icon @click="addButtonOnClick(number.inum)">
                                        <v-icon color="orange">mdi-star-plus-outline</v-icon>
                                    </v-btn>
                                </v-col>
                                <v-col class="px-0" v-if="isVisibleRemoveButton(number.inum)">
                                    <v-btn icon @click="removeButtonOnClick(number.inum)">
                                        <v-icon color="green">mdi-star-remove</v-icon>
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
    export default {
        props: {
            filterNumbers: {},
            favourites: {}
        },
        data: function () {
            return {};
        },
        computed: {},
        methods: {
            isInFavourites: function (inum) {
                return this.favourites.includes(inum);
            },
            isVisibleAddButton: function (inum) {
                return !this.isInFavourites(inum);
            },
            isVisibleRemoveButton: function (inum) {
                return this.isInFavourites(inum);
            },
            // eslint-disable-next-line no-unused-vars
            addButtonOnClick: function (inum) {
                /**
                 * Обработка click пернесена на саму v-card, cardOnClick
                 */
                // this.$emit('addToFavorites', inum)
                return;
            },
            // eslint-disable-next-line no-unused-vars
            removeButtonOnClick: function (inum) {
                /**
                 * Обработка click пернесена на саму v-card, cardOnClick
                 */
                // this.$emit('removeFromFavorites', inum)
                return;
            },
            cardOnClick: function (inum) {
                const eventName = this.isVisibleAddButton(inum) ? 'addToFavorites' : 'removeFromFavorites';
                this.$emit(eventName, inum)
            }
        }
    }
</script>
